import config from '../config';
import { datadogLogs } from '@datadog/browser-logs';

export interface EmailApiClientOptions {
  correlationId?: string;
}

export const createEmailApiClient = () => {
  return (path: string, init?: RequestInit, options?: EmailApiClientOptions): Promise<Response> => {
    const baseUrl = config.emailApiUrl;

    if (!baseUrl) {
      throw new Error('Email API Url is not configured');
    }

    const correlationId = options?.correlationId ?? crypto.randomUUID();
    const attemptId = crypto.randomUUID();

    const basePath = baseUrl.slice(baseUrl.lastIndexOf('/'));
    const headers = new Headers(init?.headers);
    headers.set('Coolblue-CorrelationId', correlationId);
    headers.set('Coolblue-AttemptId', attemptId);

    // Failures are logged here rather than in the callers because this is the only place that
    // knows the correlation id, and email_api logs the same id — that is what joins the two sides.
    const failure = {
      channel: 'email',
      correlationId,
      attemptId,
      http: { method: init?.method ?? 'GET', url_path: `${basePath}${path.split('?')[0]}` }
    };

    return fetch(`${baseUrl}${path}`, { ...init, headers }).then(
      response => {
        if (!response.ok) {
          const http = { ...failure.http, status_code: response.status };
          datadogLogs.logger.error('Email API request failed', { ...failure, http });
        }

        return response;
      },
      (error: unknown) => {
        datadogLogs.logger.error('Email API request failed', failure, error as Error);
        throw error;
      }
    );
  };
};

export const emailApiClient = createEmailApiClient();
